// Place any jQuery/helper plugins in here.
(function (targetWidth) {
    var deviceWidth = screen.width;
    var ratio = deviceWidth / targetWidth;
    var viewport = document.querySelector('meta[name="viewport"]');
    if (ratio < 1) {
        viewport.setAttribute('content', 'width=device-width, initial-scale=' + ratio + ', minimum-scale=' + ratio + ', maximum-scale=' + ratio + ', user-scalable=yes');
    }
})(375);

$(function () {
    // 錨點
    $('[data-anchor-btn]').on('click.anchor', function (e) {
        e.preventDefault();
        $('html, body').animate({
            scrollTop: $(`#${$(this).data('anchor-btn')}`).offset().top
        }, 300);
        $('body').removeClass('-menuOpen');
    });

    // 收合
    $('[data-collapse-action]').on('click', function (e) {
        e.preventDefault();
        $(this).closest('[data-collapse]').toggleClass('is-open').find('[data-collapse-content]').slideToggle();
    });

    new Swiper('[data-slider="envelopes"]', {
        watchOverflow: true,
        slidesPerView: 'auto',
        spaceBetween: 30,
        simulateTouch: true,
        loop: false,
        centerInsufficientSlides: true,
        autoplay: {
            delay: 5000,
            disableOnInteraction: false
        },
        pagination: {
            el: '.swiper-pagination',
            enabled: true,
            clickable: true
        },
        breakpoints: {
            768: {
                spaceBetween: 0,
                simulateTouch: false
            }
        }
    });

    new Swiper('[data-slider="card"]', {
        watchOverflow: true,
        slidesPerView: 1,
        spaceBetween: 20,
        simulateTouch: true,
        loop: true,
        autoplay: {
            delay: 5000,
            disableOnInteraction: false
        },
        pagination: {
            el: '.swiper-pagination',
            enabled: true,
            clickable: true
        },
        breakpoints: {
            768: {
                slidesPerView: 3,
                simulateTouch: false,
            }
        }
    });
})